export default [
  { id: 1, label: 'Amusnet' },
  { id: 2, label: 'Amatic' },
  { id: 3, label: 'Skywind' },
  { id: 4, label: 'CT Interactive' },
  { id: 5, label: 'Novomatic' },
  { id: 6, label: 'Spribe' },
  { id: 7, label: 'Pragmatic' },
  { id: 8, label: 'Evolution' },
  { id: 9, label: 'iSoftBet' },
  { id: 10, label: 'Relax Gaming' },
  { id: 11, label: 'EGT Digital' },
  { id: 12, label: 'Nevada' },
  { id: 13, label: 'OmniPlay' },
  { id: 15, label: 'Hacksaw' },
  { id: 16, label: 'Wazdan' },
  { id: 17, label: 'Playson' },
  { id: 18, label: 'Playtech' },
  { id: 20, label: 'Section8' },
  { id: 21, label: 'Split The Pot' },
  { id: 22, label: 'Booming' },
  { id: 23, label: 'Pateplay' },
  { id: 24, label: 'Solidicon' },
  { id: 25, label: 'Inspired' },
  { id: 26, label: 'Relum' },
  { id: 27, label: 'Dream Play' },
  { id: 65, label: '77 Gaming' },
  { id: 66, label: 'Formula Spin' },
  { id: 67, label: 'Popiplay' },
  { id: 68, label: 'FBastards' },
  { id: 69, label: 'AvatarUX' },
  { id: 70, label: 'Orbital Gaming' },
  { id: 71, label: 'Concept Gaming' },
  { id: 72, label: 'Rival' },
  { id: 73, label: 'Big Pot' },
  { id: 74, label: 'Jade Rabbit Studio' },
  { id: 75, label: 'Zeus Play' },
  { id: 76, label: 'TaDa' },
  { id: 77, label: 'Thunderspin' },
  { id: 78, label: 'Espresso' },
  { id: 79, label: 'Aviatrix' },
  { id: 80, label: 'Smart Soft' },
  { id: 81, label: '7 Mojos' },
  { id: 82, label: 'Platipus' },
  { id: 83, label: 'Swintt' },
  { id: 84, label: 'Absolute Live Gaming' },
  { id: 85, label: 'Triple Cherry' },
  { id: 86, label: 'Slotmatrix' },
  { id: 87, label: 'Kalamba' },
  { id: 88, label: 'Qora' },
  { id: 89, label: 'Eurasian Gaming' },
  { id: 90, label: 'Yggdrasil' },
  { id: 91, label: 'Noble Gaming' },
  { id: 92, label: 'MaxWin Gaming' },
  { id: 93, label: 'GMW' },
  { id: 94, label: 'Eyecon' },
  { id: 95, label: 'Global Bet' },
  { id: 96, label: 'Felix Gaming' },
  { id: 97, label: 'Nucleus Gaming' },
  { id: 98, label: 'GameArt' },
  { id: 99, label: 'Vivo Gaming' },
  { id: 100, label: 'Betsolutions' },
  { id: 101, label: 'Ezugi' },
  { id: 102, label: 'TV Bet' },
  { id: 103, label: 'Tom Horn' },
  { id: 104, label: 'Fugaso' },
  { id: 105, label: 'InBet' },
  { id: 106, label: 'Lucky Streak' },
  { id: 107, label: 'Belatra' },
  { id: 108, label: 'Genii' },
  { id: 114, label: 'BetGames' },
  { id: 115, label: 'BetSoft' },
  { id: 117, label: 'Live Vegas' },
  { id: 118, label: 'Reelplay' },
  { id: 119, label: 'RubyPlay' },
  { id: 120, label: 'SA Gaming' },
  { id: 121, label: 'Tombala' },
  { id: 122, label: 'Zillion Games' },
  { id: 123, label: 'Aspect Gaming' },
  { id: 124, label: 'EvoPlay' },
  { id: 125, label: 'JDB' },
  { id: 126, label: 'Kiron' },
  { id: 127, label: 'Leap Gaming' },
  { id: 128, label: 'Slotopia' },
  { id: 129, label: 'SpadeGaming' },
  { id: 130, label: 'Spinomenal' },
  { id: 131, label: '7777 gaming' },
  { id: 132, label: 'BF Games' },
  { id: 133, label: 'GamZix' },
  { id: 134, label: 'Onetouch' },
];

export const GameProviderId = {
    EGT: 1,
    AMATIC: 2,
    SKYWIND: 3,
    CT: 4,
    NOVOMATIC: 5,
    SPRIBE: 6,
    PRAGMATIC: 7,
    EVOLUTION: 8,
    ISOFTBET: 9,
    RELAX: 10,
    EGT_DIGITAL: 11,
    NEVADA: 12,
    OMNIPLAY: 13,
    HACKSAW: 15,
    WAZDAN: 16,
    PLAYSON: 17,
    PLAYTECH: 18,
    SECTION8: 20,
    SPLIT_THE_POT: 21,
    BOOMING: 22,
    PATEPLAY: 23,
  SOLIDICON: 24,
  INSPIRED: 25,
  RELUM: 26,
  IMAGINE_LIVE: 145,
  GALAXYS: 148,
};
